function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export var LocalStorageUtils = /*#__PURE__*/function () {
  function LocalStorageUtils() {
    _classCallCheck(this, LocalStorageUtils);
  }
  _createClass(LocalStorageUtils, null, [{
    key: "get",
    value: function get(key) {
      return window.localStorage.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      window.localStorage.removeItem(key);
    }
  }, {
    key: "getBoolean",
    value: function getBoolean(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (defaultValue) {
        return LocalStorageUtils.get(key) !== "false";
      } else {
        return LocalStorageUtils.get(key) === "true";
      }
    }
  }, {
    key: "setBoolean",
    value: function setBoolean(key, value) {
      LocalStorageUtils.set(key, value ? "true" : "false");
    }
  }, {
    key: "getObject",
    value: function getObject(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var data = this.get(key);
      if (!data) {
        return defaultValue;
      }
      try {
        return JSON.parse(data);
      } catch (e) {}
      return defaultValue;
    }
  }, {
    key: "setObject",
    value: function setObject(key, value) {
      if (typeof value !== "boolean" && (!value || _typeof(value) !== "object")) {
        this.remove(key);
        return;
      }
      this.set(key, JSON.stringify(value));
    }
  }]);
  return LocalStorageUtils;
}();